if (!AFRAME.components['movablexz']) {
	AFRAME.registerComponent('movablexz', {
		schema: {
			position: { type: 'vec3', default: '0 0 0' },
			offset: { type: 'vec3', default: '0 0 0' },
			startPos: { type: 'vec3', default: '0 0 0' }
		},
		moving: false,
		plane: null,
		moving: false,
		init: function() {
			this.bodyloaded = AFRAME.utils.bind(this.bodyloaded, this);
			this.el.addEventListener('body-loaded', this.bodyloaded);
			// Angular damping so the object doesn't rotate
			event.target.setAttribute('dynamic-body', 'angularDamping:1;');
			this.mouseout = AFRAME.utils.bind(this.mouseout, this);
			this.mousedown = AFRAME.utils.bind(this.mousedown, this);
			this.mouseup = AFRAME.utils.bind(this.mouseup, this);
			this.collide = AFRAME.utils.bind(this.collide, this);
			this.el.sceneEl.addEventListener('mouseout', this.mouseout);
			this.el.addEventListener('mousedown', this.mousedown);
			this.el.addEventListener('mouseup', this.mouseup);
			this.el.addEventListener('collide', this.collide);
		},
		mousedown: function(evt) {
			document
				.querySelector('[orbit-controls]')
				.setAttribute('orbit-controls', 'enableRotate', 'false');
			this.moving = true;
			this.el.body.wakeUp();
			this.el.body.allowSleep = false; // Don't let the model go to sleep while we're moving it.
			var elPos = this.el.getAttribute('position');
			var pnt = evt.detail.intersection.point;
			this.data.offset.x = pnt.x - this.el.body.position.x;
			this.data.offset.y = pnt.y - this.el.body.position.y;
			this.data.offset.z = pnt.z - this.el.body.position.z;
			this.plane = document.createElement('a-plane');
			this.el.sceneEl.appendChild(this.plane);
			this.plane.setAttribute('intersect-plane', '');
			this.plane.setAttribute('width', 20);
			this.plane.setAttribute('height', 20);
			this.plane.setAttribute('material', 'opacity:0; side:double');
			this.plane.setAttribute('rotation', '90 0 0');
			this.plane.setAttribute('position', pnt.x + ' ' + pnt.y + ' ' + pnt.z);
			this.plane.movable = this.el;
			this.moving = true;
		},
		bodyloaded: function(evt) {
			var self = this;
			setTimeout(function() {
				// Stops the jittering
				self.el.body.world.allowSleep = true;
				self.el.body.allowSleep = true;
				self.el.body.sleepSpeedLimit = 0.3;
				self.el.body.sleepTimeLimit = 0.5;
				// self.el.body.addEventListener("sleepy",function(event){
				// 	console.log("The object is feeling sleepy...");
				// });
			}, 0);
		},
		mouseup: function(evt) {
			document
				.querySelector('[orbit-controls]')
				.setAttribute('orbit-controls', 'enableRotate', 'true');
			this.moving = false;
			this.el.body.allowSleep = true;
			// Wake all physics up when releasing, this stops objects from floating.
			var childNodes = this.el.sceneEl.childNodes;
			for (var i = 0; i < childNodes.length; i++) {
				if (
					childNodes[i].getAttribute &&
					childNodes[i].getAttribute('movable') != undefined
				) {
					childNodes[i].body.wakeUp();
				}
			}
		},
		mouseout: function(evt) {
			document
				.querySelector('[orbit-controls]')
				.setAttribute('orbit-controls', 'enableRotate', 'true');
			this.moving = false;
			this.el.body.allowSleep = true;
		},
		collide: function(evt) {
			//console.log(evt);
		},
		tick: function() {
			if (this.el.body && this.el.body.position.y <= -7) {
				this.el.body.velocity.set(0, 0, 0);
				this.el.body.position.set(
					this.data.startPos.x,
					this.data.startPos.y,
					this.data.startPos.z
				);
			}
			var pos = this.el.body.position;
			this.el.body.position.set(pos.x, pos.y, pos.z);
		},
		tock: function() {
			// this.el.body.angularVelocity.set(0,0,0);
			// this.el.body.quaternion.set(0,0,0,1);
		},
		remove: function() {
			this.el.removeEventListener('mousedown', this.mousedown);
			this.el.removeEventListener('mouseup', this.mouseup);
			this.el.removeEventListener('collide', this.collide);
		}
	});
}
